import { FC } from "react";

interface CardHeadlineProps {
    title?: string;
    headlineId?: string;
}

const CardHeadline: FC<CardHeadlineProps> = ({ headlineId, title }) => {
    if (!title) return null;

    return (
        <div className="card-cqw-headline" data-testid="card-cqw-headline">
            <h3
                className="headline"
                id={headlineId}
                data-testid="card-cqw-headline-text"
            >
                {title}
            </h3>
        </div>
    );
};

export default CardHeadline;
